const attributes = [
    {
        isHeader: true,
        name: 'fileName',
        sortable: true,
        sortBy: 'fileName',
        hideValue: true,
        label: 'Name',
        showInCard: false,
        component: {
            componentName: 'HighlightedClickableLabel',
            queryParam: 'id',
            idParam: 'trackingID',
            // idParam: 'csvInboxID',
        },
        headerCellStyles: {
            minWidth: '180px',
        },
        styles: {
            color: '#9230c5',
            fontSize: '16px',
            fontWeight: 'bold',
            marginTop: '6px',
            marginLeft: '10px',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        link: false,
    },
    {
        name: 'ticketNumber',
        sortable: true,
        showInCard: true,
        sortBy: 'ticketNumber',
        label: 'TicketNumber',
        // headerCellStyles: {
        //     minWidth: '105px',
        // },
        styles: {
            color: '#282828',
            fontSize: '13px',
            marginTop: '6px',
        },
    },
    {
        name: 'csvInboxTypeName',
        sortable: true,
        showInCard: true,
        sortBy: 'csvInboxTypeName',
        label: 'InboxType',
        // headerCellStyles: {
        //     minWidth: '105px',
        // },
        styles: {
            color: '#282828',
            fontSize: '13px',
            marginTop: '6px',
        },
    },
    {
        name: 'categoryName',
        sortable: true,
        showInCard: true,
        sortBy: 'categoryName',
        label: 'Category',
        // headerCellStyles: {
        //     minWidth: '105px',
        // },
        styles: {
            color: '#282828',
            fontSize: '13px',
            marginTop: '6px',
        },
    },
    {
        name: 'totalItemCount',
        sortable: true,
        showInCard: true,
        sortBy: 'totalItemCount',
        label: 'UploadedItems',
        // headerCellStyles: {
        //     minWidth: '105px',
        // },
        styles: {
            color: '#282828',
            fontSize: '13px',
            marginTop: '6px',
        },
    },
    {
        name: 'rtA_CSVInboxStatusName',
        sortable: true,
        showInCard: true,
        sortBy: 'rtA_CSVInboxStatusName',
        hideValue: true,
        label: 'Status',
        component: {
            componentName: 'StatusIndicator',
            name: 'rtA_CSVInboxStatusName',
            props: {
                size: 'medium',
            },
        },
    },
    {
        name: 'createdByFriendlyName',
        sortable: true,
        showInCard: true,
        sortBy: 'createdByFriendlyName',
        label: 'UploadedBy',
        hideValue: true,
        component: {
            componentName: 'SubjectType',
            props: {
                nameProp: 'createdByFriendlyName',
                imgSrcProp: 'creatorImageUrl',
            },
        },
    },
    {
        name: 'createdDate',
        sortable: true,
        showInCard: true,
        sortBy: 'createdDate',
        label: 'ElapsedTime',
        hideValue: true,

        component: {
            size: 'small',
            calculateFromDate: true,
            componentName: 'CalculateTimeString',
        },
        // headerCellStyles: {
        //     minWidth: '120px',
        // },
        styles: {
            color: '#282828',
            fontSize: '13px',
            marginTop: '6px',
        },
    },
    {
        name: 'comments',
        sortable: true,
        showInCard: true,
        sortBy: 'comments',
        label: 'Comment',
        // headerCellStyles: {
        //     maxWidth: '150px',
        // },
        styles: {
            fontSize: '13px',
            whiteSpace: 'normal',
            color: '#282828',
        },
    },
    {
        hideValue: true,
        showInCard: false,
        
        component: {
            componentName: 'actionButtons',
            props: {
                queryParam: 'id',
                idParam: 'trackingID',
                // idParam: 'csvInboxID',
                disabledKey: 'totalItemCount',
            },
        },
    },
]

export default attributes
